import styled from 'styled-components';

export const Icon = styled.img``;

export const SecurityButtonWrapper = styled.div`
  display: flex;
  gap: 20px;
`;

export const SecurityLabel = styled.p`
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
`;

export const SecurityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
`;
